module.exports = "/_next/static/pages/test-guidelines/94c458d0c5d515d21cd3007f70531362.png";